(function () {
    'use strict';

    angular.module('app').controller('GoodsController', GoodsController).directive('nacsCode', nacsValidator);

    GoodsController.$inject = [
        '$rootScope',
        '$scope',
        '$timeout',
        '$route',
        '$routeParams',
        '$location',
        '$filter',
        '$translate',
        '$uibModal',
        'blockUI',
        'GoodsService',
        'SelectService',
        'BusinessService',
        'NotifyService',
        'LANGS',
        'SettingsService'
    ];

    function GoodsController(
        $rootScope,
        $scope,
        $timeout,
        $route,
        $routeParams,
        $location,
        $filter,
        $translate,
        $uibModal,
        blockUI,
        GoodsService,
        SelectService,
        BusinessService,
        NotifyService,
        LANGS,
        SettingsService
    ) {

        var isFuelMode = !!$route.current.$$route.isFuelMode;
        $scope.isFuelMode = isFuelMode;

        $scope.selectedGoods = {};
        $scope.selectedGoodsCount = selectedGoodsCount;
        $scope.selectedGoodsAll = false;
        $scope.isPageMode = isPageMode;

        $scope.getCurrenciesList = getCurrenciesList;
        $scope.specialAccountsList = [];
        $scope.makeAccountsList = SelectService.makeBusinessSpecialAccountsList;
        $scope.corporateSpecialAccountsList = [];
        $scope.makeCorporateAccountsList = SelectService.makeBusinessCorporateSpecialAccountsList;
        $scope.getLoyaltiesList = SelectService.getLoyaltiesList;
        $scope.getGoodsCategoriesList = SelectService.getGoodsCategoriesList;
        $scope.filterHelper = {
            serviceType: isFuelMode ? 'fuel' : 'all'
        };

        $scope.multilang = MultilanguageHelper();
        $scope.currentLangCode = $scope.multilang.lang;
        $scope.initLocaleStrings = initLocaleStrings;

        $scope.getPages = getTotalPaginatedPages;
        $scope.hexToInt = hexToInt;
        $scope.intToHEX = intToHEX;

        // $scope.currencyList = {};

        $scope.data = {
            image: {
                src: '',
                cropped: '',
                new: false,
                loading: false,
                delete: false,
            },
            // Category color
            colors: ['ffffff', '2ecc71', '2980b9', '8e44ad', '2c3e50', 'f1c40f', 'e67e22', 'd35400', 'c0392b', 'bdc3c7', '98a3a3'],

            showGoodsListMode: $rootScope.ENV.ShowGoodsMode ? $rootScope.ENV.ShowGoodsMode : 'all',
            pager: {
                page: 1,
                count: $rootScope.ENV.PAGER_COUNT || 10
            },

            requestInvoked: false,

            // Goods category
            categoryId: $rootScope.ENV.LastGoodsCategory ? $rootScope.ENV.LastGoodsCategory : '0',

            additional_image_file: '',

            service_types: [],

            characteristicList: [
                {
                    title: 'BULK',
                    type: 'BULK',
                    property: 'whole_number'
                },
                {
                    title: 'WEIGHT',
                    type: 'WEIGHT',
                    property: 'weighing'
                },
                {
                    title: 'VPRICE',
                    type: 'VPRICE',
                    property: 'variable_price'
                },
                {
                    title: 'VAMOUNT',
                    type: 'VAMOUNT',
                    property: 'variable_total'
                }
            ],
            volume_unit: null,
            measureUnits: ['L', 'G']
        };


        $scope.pager_count = [10, 20, 50, 100];

        $scope.currentTab = 'general';

        var goods_list = blockUI.instances.get('goods_list');
        var block_goods_edit = blockUI.instances.get('goods_edit');
        var block_goods_online_store = blockUI.instances.get('goods_online_store');
        var block_product_price = blockUI.instances.get('product_price');
        var block_product_recommended_values = blockUI.instances.get('product_recommended_values');
        var block_goods_list_modal = blockUI.instances.get('goods_list_modal');

        $scope.maxAdditionalImageSize = 700; //in Kb

        var filterTimeout, goodsTimeout;

        $scope.baseUrl = isFuelMode ? '/fuel-goods' : '/goods-and-services';

        $scope.platformSupportedLanguagesCodes = Object.keys(LANGS) || [];
        SettingsService.GetPlatformSupportedLanguages(function (success, response) {
            $scope.platformSupportedLanguagesCodes = response;
        });
        initController();

        // *********************************************************************************************
        //  MAIN PART
        // *********************************************************************************************

        /**
         * Page mode display different parts. Now 'show', 'create', 'edit'.
         * Use as <ANY ng-if="isPageMode('show')">
         */
        function isPageMode(mode) {
            return mode == $scope._pageMode;
        }

        /**
         * Check parameter 'mode' in route ../client-accounts/{mode}
         */
        function isRouteMode(mode) {
            return $routeParams && $routeParams.hasOwnProperty('mode') && $routeParams.mode === mode;
        }

        /**
         * Initialize page mode by url
         */
        function initPageMode() {
            $scope._pageMode = 'show';
            if (isRouteMode('edit')) {
                $scope._pageMode = ($routeParams.hasOwnProperty('item_id')) ? 'edit' : 'show';
            } else if (isRouteMode('create')) $scope._pageMode = 'create';
        }

        /**
         * Initialize controller
         */
        function initController() {

            $scope.multilang.initLangs(LANGS, $rootScope.LANG);
            $scope.currentLangCode = $scope.multilang.lang;
            initPageMode();

            switch ($scope._pageMode) {
                case 'create':
                    doCreate();
                    break;

                case 'show':
                    doShow();
                    break;

                case 'edit':
                    doEdit();
                    break;
            }

            if ($routeParams['tab'] && $routeParams['tab'] == 'recommended_value') {
                initRecommendedValue();
            }
        }

        // *********************************************************************************************
        //  SHOW PART
        // *********************************************************************************************

        /**
         * Prepare data for display page in mode 'show'
         */
        function doShow() {
            if ($scope.filterHelper.id) {

                showGoodsList();

                $timeout.cancel(goodsTimeout);
            } else {
                goodsTimeout = $timeout(doShow, 250);
            }

            // initServiceTypes();
        }

        SettingsService.GetPlatformParams(function (success, response) {
            if (success) {
                $scope.platformParams = response;
            }
        });

        /**
         *
         */
        function showGoodsList() {

            goods_list.start();

            if ($scope.data.showGoodsListMode === 'all') {
                var params = {
                    page: $scope.data.pager.page,
                    count: $scope.data.pager.count,
                    search_text: $scope.data.searchText
                };
                params.only_active = !$scope.data.showDisabledItems;

                var isFeatureFilter = $scope.data.characteristicList.find(function (item) {
                    return item.type === $scope.filterHelper.serviceType;
                });
                params.service_type = 'all';

                if (isFeatureFilter) {
                    /*

                    *** Should uncommented after backend fixes ***

                    params[isFeatureFilter.property] = 1;
                    */
                } else {
                    params.service_type = $scope.filterHelper.serviceType || 'all';
                }
                if (isFuelMode) {
                    params.service_type = 'fuel';
                }
                GoodsService.GoodsInLoyalty($scope.filterHelper.id, params, function (success, data) {
                    if (success) {
                        if (isFeatureFilter) {
                            $scope.goodsList = data.data.filter(function (item) {
                                return item[isFeatureFilter.property] == 1;
                            });
                        } else {
                            $scope.goodsList = data.data;
                        }
                        $scope.data.pager.total_rows_count = data.summary.total_rows_count;
                    }
                    goods_list.stop();
                });
            } else {
                var categoryId = $scope.data.categoryId != '0' ? $scope.data.categoryId : null;
                var params = {
                    only_active: !$scope.data.showDisabledItems
                };
                if (categoryId) {
                    params.category = categoryId;
                }
                params.service_type = 'all';
                if (isFuelMode) {
                    params.service_type = 'fuel';
                }
                GoodsService.GoodsInCategory($scope.filterHelper.id, params, function (success, data) {
                    if (success) {
                        $scope.goodsList = data;
                    }
                    goods_list.stop();
                });
            }
        }

        /**
         * Click on 'Create good/service' button
         */
        $scope.onCreateGoodsClick = function () {
            $scope.currentTab = 'general';
            $location.url($location.$$path + '/create?tab=' + $scope.currentTab);

        };

        /**
         * Goods enable/disable click
         */
        $scope.onGoodsToggleClick = function (product) {
            var post_data = product;
            post_data.active = post_data.active == 1 ? 0 : 1;

            GoodsService.GoodsEdit(product.id, post_data, function (success, data) {
                if (success) {
                    product.active = data.active;
                }
            });
        };

        /**
         * Receive message when loyalty list loaded
         */
        // $scope.onLoyaltyComplete = function (items) {
        //     if (!$scope.filterHelper.isLoyalty()) {
        //         $scope.filterHelper.id = items[0].id;
        //         items[0].selected = true;
        //         $scope.onSelectLoyaltyFilter(items[0].id, items[0].object);
        //     }
        // };

        /**
         * Change goods view mode
         */
        $scope.onShowListModeClick = function () {
            $rootScope.ENV.ShowGoodsMode = $scope.data.showGoodsListMode;
            $rootScope.storeENV();
            showGoodsList();
        };

        function initServiceTypes() {
            GoodsService.GetServiceTypes(function (success, data) {
                if (success) {
                    $scope.data.service_types = data.map(function (type) {
                        type['isChecked'] = !!(!!$scope.service_types && $scope.service_types.includes(type.type));
                        return type;
                    });
                }
            });
        }

        /**
         * Toggle service type
         */
        $scope.toggleServiceType = function (type) {

            var typeIndex = $scope.service_types.indexOf(type.type);

            if (typeIndex === -1 && type.isChecked == true) {
                $scope.service_types.push(type.type);
            } else if (typeIndex >= 0 && type.isChecked == false) {
                $scope.service_types.splice(typeIndex, 1);
            }

            $scope.model.service_types = $scope.service_types;

            if ($scope.model.id) {
                // function receiveResult(success, data) {
                //     if (success) {
                //         NotifyService.Success('', false);
                //     } else {
                //         NotifyService.Error('', false);
                //     }
                // }

                var post_data = angular.copy($scope.model);
                post_data.color = hexToInt($scope.data.color);
                if (post_data.parent_id == '0') post_data.parent_id = null;

                GoodsService.GoodsEdit(post_data.id, post_data, function (success, data) {
                    if (success) {
                        NotifyService.Success('', false);
                    } else {
                        NotifyService.Error('', false);
                    }
                });
            }
        };

        // *******************************  SHOW SORTABLE LIST  ****************************************

        $scope.onSaveGoodsOrderClick = function () {
            var post_data = [];
            $scope.goodsList.forEach(function (item) {
                post_data.push(item.id);
            });
            GoodsService.GoodsStoreOrder(
                $scope.filterHelper.id,
                $scope.data.categoryId != '0' ? $scope.data.categoryId : null,
                post_data, function (success, data) {
                    if (success) {
                        $scope.goodsList = data;
                    }
                });
        };

        // *************************************  SHOW TABLE  *******************************************

        /**
         * handling items on page count
         */
        $scope.onCountChange = function (count) {
            $scope.data.pager.page = 1;
            $scope.data.pager.count = count;
            $rootScope.ENV.PAGER_COUNT = count;
            $rootScope.storeENV();

            showGoodsList();
        };

        $scope.onChangeShowOnlyActive = function () {
            showGoodsList();
        };

        /**
         * Received when user chane page
         */
        $scope.pageChange = function () {
            showGoodsList();
        };

        $scope.onShowGoodsClick = function () {
            $scope.data.pager.page = 1;
            showGoodsList();
        };

        $scope.onFilterChange = function () {
            if (filterTimeout) {
                $timeout.cancel(filterTimeout);
            }

            filterTimeout = $timeout(function () {
                $scope.data.pager.page = 1;
                showGoodsList();
            }, 1000);
        };

        // *********************************************************************************************
        //  CREATE & EDIT PART
        // *********************************************************************************************

        /**
         * Init loyalty string
         */
        function initLocaleStrings(goods) {
            $scope.multilang.initStrings(goods, ['public_title', 'public_description']);
        }

        /**
         * Make currency list for <select> element
         //  */
        function getCurrenciesList() {
            if (!$scope.data.currenciesList || $scope.data.currenciesList.length === 0)
                BusinessService.CurrencyList(null, function (success, response) {
                    if (success) {
                        $scope.data.currenciesList = response;

                        if ($scope.data.currenciesList.indexOf('EUR') == -1)
                            $scope.data.currenciesList.push('EUR');

                        if ($scope.data.currenciesList.indexOf('USD') == -1)
                            $scope.data.currenciesList.push('USD');
                    }
                });
        }

        // function makeCurrencyList() {
        //     if ($rootScope.ENV.business && $rootScope.ENV.business.currency) {
        //         $scope.currencyList[$rootScope.ENV.business.currency] = $rootScope.ENV.business.currency;
        //     } else {
        //         BusinessService.Get(function (success, data) {
        //             if (success){
        //                 delete data.auto_pay_params;
        //                 $rootScope.ENV.business = data;
        //                 $rootScope.storeENV();

        //                 if ($rootScope.ENV.business.currency) {
        //                     $scope.currencyList[$rootScope.ENV.business.currency] = $rootScope.ENV.business.currency_title;
        //                 }
        //             }
        //         });
        //     }

        //     BusinessService.CurrencyList($scope.filterHelper.id, function(success, response) {
        //         if (success) {
        //             for (var i in response) {
        //                 $scope.currencyList[response[i]] = response[i];
        //             }
        //         }

        //         $scope.currencyList.EUR = 'EUR';
        //         $scope.currencyList.USD = 'USD';
        //     });
        // }

        function makeAccountsList(callback) {
            $scope.makeAccountsList(function (data) {
                if (data) {
                    $scope.specialAccountsList = [];
                    for (var i in data)
                        if (data[i].active === 1)
                            $scope.specialAccountsList.push(data[i]);
                }
                callback(true);
            });
            $scope.makeCorporateAccountsList(function (data) {
                if (data) {
                    $scope.corporateSpecialAccountsList = [];
                    for (var i in data)
                        if (data[i].active === 1)
                            $scope.corporateSpecialAccountsList.push(data[i]);
                }
                callback(true);
            });
        }

        /**
         * Prepare data for display page in mode 'create'
         */
        function doCreate() {
            // makeCurrencyList();
            getCurrenciesList();
            makeAccountsList(function (success) {
                if (success) {
                    $scope.prices = [];
                    $scope.service_types = [];
                    if (isFuelMode) {
                        $scope.service_types.push('fuel');
                    }
                    $scope.recommended_values = [];
                    $scope.model = {
                        loyalty_id: $scope.filterHelper.id,
                        parent_id: '0',
                        color: 4294967295,
                        active: 1,
                        whole_number: 1,
                        fleet_cards: 0,
                        online_store_available: 0,
                        price: $scope.prices,
                        recommended_values: $scope.recommended_values,
                        service_types: $scope.service_types,
                        passthru_data: {
                            fleet: {
                                measure_unit: undefined,
                                product_code: undefined
                            }
                        }
                    };

                    $scope.initLocaleStrings($scope.model);

                    $scope.data.color = intToHEX($scope.model.color);
                    $scope.isPriceModified = false;
                    if ($routeParams['tab']) {
                        $scope.currentTab = $routeParams['tab'];
                    }

                    initServiceTypes();
                }
            });
        }

        /**
         * Prepare data for display page in mode 'edit'
         */
        function doEdit() {
            block_goods_edit.start();
            // makeCurrencyList();
            getCurrenciesList();

            makeAccountsList(function (success) {
                GoodsService.Goods($routeParams.item_id, function (success, data) {

                    if (success) {
                        $scope.model = angular.copy(data);
                        $scope.prices = $scope.model.price;
                        $scope.recommended_values = $scope.model.preconfigured_values ? $scope.model.preconfigured_values : [];
                        $scope.service_types = $scope.model.service_types ? $scope.model.service_types : [];
                        $scope.data.color = intToHEX($scope.model.color);
                        $scope.isPriceModified = false;

                        if ($scope.model.passthru_data && $scope.model.passthru_data.fleet) {
                            if ($scope.model.passthru_data.fleet.measure_unit && $scope.model.passthru_data.fleet.product_code) {
                                $scope.model.fleet_cards = 1;
                            } else {
                                $scope.model.fleet_cards = 0;
                            }
                        }

                        $scope.new_price = {
                            type: 'currency',
                            currency: $rootScope.ENV.business.currency,
                            price_decimal_digits: $rootScope.ENV.decimal_digits,
                            price_decimal_digits_visible: false,
                            special_account: $scope.specialAccountsList[0]
                        };

                        // add business currency to currenciesList
                        if ($scope.data.currenciesList.indexOf($scope.new_price.currency) == -1)
                            $scope.data.currenciesList.push($scope.new_price.currency);

                        if (!$scope.model.parent_id)
                            $scope.model.parent_id = '0';

                        if (!!$scope.model.unit)
                            $scope.data.volume_unit = $scope.model.unit;

                        $scope.initLocaleStrings($scope.model);

                        $scope.filterHelper.id = $scope.model.loyalty_id;

                        initServiceTypes();
                    }
                    block_goods_edit.stop();
                });

                if ($routeParams['tab']) {
                    $scope.currentTab = $routeParams['tab'];
                }
            });
        }

        /**
         * Raised when user select local file
         * @param evt
         */
        $scope.handleFileSelect = function (evt) {
            var file = evt.currentTarget.files[0],
                reader = new FileReader();

            var imageType = file.type,
                isPng = imageType === 'image/png';

            reader.onload = function (e) {
                var img = new Image();

                img.onload = function () {
                    var canvas = document.getElementById('file-canvas'),
                        ctx = canvas.getContext('2d'),
                        width = img.width,
                        height = img.height,
                        maxAllowedSize = 2 * 1024 * 1024;

                    canvas.width = width;
                    canvas.height = height;
                    ctx.clearRect(0, 0, width, height);
                    ctx.drawImage(img, 0, 0, width, height);

                    var resizedImageDataUrl;

                    if (isPng) {
                        resizedImageDataUrl = canvas.toDataURL('image/png');
                    } else {
                        resizedImageDataUrl = canvas.toDataURL('image/jpeg', 1);
                    }

                    if (resizedImageDataUrl.length > maxAllowedSize) {
                        var scale = 0.95,
                            quality = 1;

                        do {
                            width = Math.round(img.width * scale);
                            height = Math.round(img.height * scale);

                            canvas.width = width;
                            canvas.height = height;
                            ctx.clearRect(0, 0, width, height);
                            ctx.drawImage(img, 0, 0, width, height);

                            if (isPng) {
                                resizedImageDataUrl = canvas.toDataURL('image/png');
                            } else {
                                quality = Math.max(quality - 0.05, 0.1);
                                resizedImageDataUrl = canvas.toDataURL('image/jpeg', quality);
                            }

                            scale -= 0.05;
                        } while (
                            resizedImageDataUrl.length > maxAllowedSize &&
                            width > 50 && height > 50
                            );
                    }

                    $scope.$apply(function () {
                        $scope.data.image.cropped = '';
                        $scope.data.image.loading = false;
                        $scope.data.image.new = true;
                        $scope.data.image.src = resizedImageDataUrl;
                    });
                };
                img.src = e.target.result;
            };

            reader.readAsDataURL(file);
        };

        $scope.initImgCrop = function () {
            var file = angular.element(document.getElementById('goodsPicture'));
            file.on('change', $scope.handleFileSelect);
        };

        /**
         * Raised when user select local file additional image
         * @param evt
         */
        $scope.handleImageFileSelect = function (file_event) {
            console.info('FILE EVENT', file_event);
            for (var i = 0; i < file_event.currentTarget.files.length; i++) {
                var file = file_event.currentTarget.files[i];
                console.info('FILE', file);

                if (file.size < ($scope.maxAdditionalImageSize * 1024)) {
                    var reader = new FileReader();
                    reader.onload = function (event) {
                        $scope.$apply(function ($scope) {
                            GoodsService.UploadGoodsAddImage($scope.model.id, event.target.result, function (success, data) {
                                if (success) {
                                    NotifyService.Success('', false);

                                    $scope.model.additional_images = angular.copy(data.additional_images);
                                }
                            });
                        });
                    };

                    reader.readAsDataURL(file);
                } else {
                    var msg_template = $translate.instant('File {0} exceeded max size ({1} Kb)', {}, undefined, false, undefined);
                    NotifyService.Error(msg_template.format(file.name, $scope.maxAdditionalImageSize), false);
                }
            }

            var file = angular.element(file_event.currentTarget);
            file.val(null);
        };

        $scope.initImgAdd = function () {
            var file = angular.element(document.getElementById('additional_image_add'));
            file.on('change', $scope.handleImageFileSelect);
        };

        $scope.onDeleteAdditionalImage = function (item) {
            if (item && item.id) {

                block_goods_online_store.start();
                GoodsService.DeleteGoodsAddImage($scope.model.id, item.id, function (success, data) {
                    if (success) {
                        NotifyService.Success('', false);

                        $scope.model.additional_images = angular.copy(data.additional_images);
                    }
                    block_goods_online_store.stop();
                });
            }
        };

        /**
         * handling color selector in edit/create goods
         */
        $scope.onColorSelectClick = function (color) {
            $scope.data.color = color;
        };

        /**
         * Main tabs changes. Need for initialize data specifics by tab
         */
        $scope.onChangeTab = function (tab) {
            console.info('TAB', tab);

            var form = angular.element('#form').scope().form;
            var online_store_form = angular.element('#online_store_form').scope().online_store_form;

            if (($scope.currentTab == 'general' && (!$scope.model.title || !$scope.model.code || form.$dirty)) ||
                ($scope.currentTab == 'online_store' && online_store_form.$dirty) ||
                ($scope.currentTab == 'price' && $scope.isPriceModified) ||
                ($scope.currentTab == 'recommended_value' && $scope.data.isRecommendedValueModified)
            ) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    keyboard: true,
                    size: 'sm',
                    templateUrl: 'app/templates/modal.confirmation.html',
                    controllerAs: 'popup',
                    controller: function ($uibModalInstance) {
                        var popup = this;

                        popup.type = 'goods';

                        popup.onSaveClick = function (exit) {

                            if ($scope.currentTab == 'general') {
                                if (form.$dirty) {
                                    $scope.saveGoodsChanges(form, false, tab);
                                } else {
                                    form.$dirty = true;
                                    form.title.$dirty = form.code.$dirty = true;
                                }
                            } else if ($scope.currentTab == 'online_store') {
                                if (online_store_form.$dirty) {
                                    $scope.saveGoodsOnlineStoreChanges(form, false, tab);
                                }
                            } else if ($scope.currentTab == 'price') {
                                if ($scope.isPriceModified) {
                                    savePrice();
                                }

                            }
                                // if (form.$dirty || $scope.isPriceModified) {
                                //     $scope.saveGoodsChanges(form, false, tab);
                                // }
                                // else {
                                //     form.$dirty = true;
                                //     form.title.$dirty = form.code.$dirty
                                //                       = true;
                            // }

                            else if ($scope.currentTab == 'recommended_value') {
                                if ($scope.data.isRecommendedValueModified) {
                                    saveRecommendedValues();
                                }
                            }

                            $uibModalInstance.close();
                        };

                        popup.onCancelClick = function (exit) {
                            if (isPageMode('create')) {
                                // $scope.currentTab = 'general';
                            } else {
                                $location.url($location.$$path + '?tab=' + tab);
                            }
                            $uibModalInstance.close();
                        };
                    }
                });
            } else {
                $scope.currentTab = tab;
                $location.url($location.$$path + '?tab=' + tab);
            }
        };

        /**
         * Cancel editing
         */
        $scope.onCancelEdit = function () {
            $location.path($scope.baseUrl);
        };

        /**
         * Event receive when change language
         */
        var unbindTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function (lang) {
            initServiceTypes();

            $scope.currentLangCode = lang.targetScope.LANG;

            if ($scope.currentTab === 'recommended_value') {
                block_product_recommended_values.start();
                GoodsService.Goods($routeParams.item_id, function (success, data) {
                    if (success) {
                        $scope.model.recommended_values = angular.copy(data.recommended_values);

                    }
                    block_product_recommended_values.stop();
                });

            }
        });

        $scope.$on('$destroy', unbindTranslateChangeSuccess);

        /**
         * Event receive when change editing language
         */
        $scope.onChangeLanguage = function (new_lang) {
            $scope.multilang.selected(new_lang);
        };

        $scope.deleteGoodsPhoto = function () {
            if ($scope.data.image.new) {
                $scope.data.image.src = '';
                $scope.data.image.new = false;
            } else if ($scope.model.image) {
                delete $scope.model.image;
                $scope.data.image.delete = true;
            }
        };

        $scope.cropGoodsPhoto = function () {
            $uibModal.open({
                animation: false,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.crop-image.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-full',
                controller: function ($uibModalInstance) {
                    var popup_crop = this;
                    popup_crop.image = angular.copy($scope.data.image);

                    popup_crop.onCancelClick = function () {
                        $uibModalInstance.close();
                    }

                    popup_crop.onCropImage = function () {
                        $scope.data.image = angular.copy(popup_crop.image);
                        $uibModalInstance.close();
                    }
                }
            })
        };

        $scope.saveGoodsChanges = function (form, needClose, tab) {
            block_goods_edit.start();
            $scope.data.requestInvoked = true;

            function receiveResult(success, data) {
                if (success) {
                    NotifyService.Success('', false);
                    if ($scope.data.image.delete && !$scope.data.image.new) {
                        GoodsService.DeleteGoodsPhoto(data.id, function (success, img_data) {
                            if (success) {
                                // empty
                                $scope.model = angular.copy(img_data);
                                $scope.data.image.delete = false;
                            }
                        });
                    } else if ($scope.data.image.new) {
                        var image = $scope.data.image.cropped || $scope.data.image.src;
                        GoodsService.UploadGoodsPhoto(data.id, image, function (success, img_data) {
                            if (success) {
                                // empty
                                $scope.model = angular.copy(img_data);
                                $scope.data.image.delete = false;
                                $scope.data.image.new = false;
                            }
                        });
                    }

                    if (tab) {
                        $location.path($scope.baseUrl + '/edit/' + data.id).search({tab: tab});
                    } else {
                        if (needClose) $location.path($scope.baseUrl);
                    }
                }

                form.$setPristine();
                $scope.data.requestInvoked = false;
                block_goods_edit.stop();
            }

            var post_data = angular.copy($scope.model);
            post_data.color = hexToInt($scope.data.color);
            if (post_data.parent_id == '0') post_data.parent_id = null;

            if (post_data.fleet_cards == '1') {
                if (!post_data.passthru_data.fleet.product_code) {
                    form.product_code.$dirty = true;
                    $scope.data.requestInvoked = false;
                    block_goods_edit.stop();
                    return
                }
                if (!post_data.passthru_data.fleet.measure_unit) {
                    form.measure_unit.$dirty = true;
                    $scope.data.requestInvoked = false;
                    block_goods_edit.stop();
                    return;
                }
            }

            if (post_data.fleet_cards == '0') {
                post_data.passthru_data = null;
            }

            delete post_data.fleet_cards;

            if (form.title.$valid && form.code.$valid) {
                if ($scope.isPageMode('create')) {
                    GoodsService.GoodsAdd(post_data, receiveResult);
                } else {
                    GoodsService.GoodsEdit(post_data.id, post_data, receiveResult);
                }
            } else {
                form.title.$dirty = true;
                form.code.$dirty = true;
                $scope.data.requestInvoked = false;
                block_goods_edit.stop();
            }
        };

        $scope.saveGoodsOnlineStoreChanges = function (form, needClose, tab) {
            console.info('FORM', form);

            block_goods_online_store.start();
            $scope.data.requestInvoked = true;

            function receiveResult(success, data) {
                if (success) {
                    NotifyService.Success('', false);

                    if (tab) {
                        $location.path($scope.baseUrl + '/edit/' + data.id).search({tab: tab});
                    } else {
                        if (needClose) $location.path($scope.baseUrl);
                    }
                }

                form.$setPristine();
                $scope.data.requestInvoked = false;
                block_goods_online_store.stop();

                console.info('FORM', form);
            }

            var post_data = angular.copy($scope.model);
            post_data.color = hexToInt($scope.data.color);
            if (post_data.parent_id == '0') post_data.parent_id = null;

            GoodsService.GoodsEdit(post_data.id, post_data, receiveResult);
        };

        $scope.onWeighingClick = function () {
            if ($scope.model.weighing) {
                $scope.model.whole_number = 0;
                $scope.model.variable_total = 0;
            }
        };

        $scope.onChangePriceDecimalDigitsVisible = function () {
            if (!$scope.new_price.price_decimal_digits_visible) {
                $scope.new_price.price_decimal_digits = $rootScope.ENV.decimal_digits;
            }
        };

        $scope.onVariablePriceClick = function () {
            if ($scope.model.variable_price) {
                $scope.model.variable_total = 0;
            }
        };

        $scope.onVariableTotalClick = function () {
            if ($scope.model.variable_total) {
                $scope.model.variable_price = 0;
                $scope.model.weighing = 0;
                $scope.model.whole_number = 0;
            }
        };

        // ============================================  PRICE TAB  ====================================================

        $scope.onPriceEditClick = function (price) {
            block_product_price.start();
            $scope.data.backupPriceValue = {
                price: price.price,
                price_decimal_digits: price.price_decimal_digits
            };
            $scope.data.CurrentPrice = price;
            $scope.data.isPriceEditMode = true;
            block_product_price.stop();
        };

        $scope.onPriceSaveEditClick = function () {
            block_product_price.start();
            $scope.isPriceModified = $scope.isPriceModified
                || $scope.data.CurrentPrice.price !== $scope.data.backupPriceValue.price
                || $scope.data.CurrentPrice.price_decimal_digits !== $scope.data.backupPriceValue.price_decimal_digits;
            $scope.data.isPriceEditMode = false;
            $scope.data.CurrentPrice = null;

            savePrice(function (success, data) {
                if (success) {

                }

                block_product_price.stop();
            });
        };

        $scope.onPriceCancelEditClick = function () {
            block_product_price.start();
            $scope.data.isPriceEditMode = false;

            $scope.data.CurrentPrice.price = $scope.data.backupPriceValue.price;
            $scope.data.CurrentPrice.price_decimal_digits = $scope.data.backupPriceValue.price_decimal_digits;

            $scope.data.CurrentPrice = null;
            block_product_price.stop();
        };

        $scope.onPriceDeleteClick = function (price) {
            var modalInstance = $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'sm',
                templateUrl: 'app/templates/modal.confirmation.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.type = 'goods-price';

                    popup.onSaveClick = function () {
                        $scope.prices.forEach(function (item) {
                            if (item == price) {
                                $scope.prices.splice($scope.prices.indexOf(price), 1);
                                $scope.isPriceModified = true;
                            }
                        });
                        savePrice();
                        $uibModalInstance.close();
                    };

                    popup.onCancelClick = function (exit) {
                        $uibModalInstance.close();
                    };
                }
            });
        };

        // $scope.onAccountsComplete = function (items) {
        //     if (items.length > 0 && $scope.new_price) {
        //         $scope.new_price.special_account_id = items[0].id;
        //         $scope.onSelectSpecialAccount(items[0].id, items[0].object);
        //     }
        // };

        $scope.onSelectCurrency = function (form) {
            form.currency.$error.duplicate = false;
        };

        /**
         * Save to server Product (goods) with price
         */
        function savePrice(callback) {
            var post_data = angular.copy($scope.model);
            post_data.price = angular.copy($scope.prices);
            post_data.price = post_data.price.map(function (price) {
                if (price.type === 'corporate-special-account') {
                    price.type = 'special-account';
                }
                return price;
            });

            console.log('post_data.price', post_data.price);
            post_data.color = hexToInt($scope.data.color);
            if (post_data.parent_id == '0') post_data.parent_id = null;

            GoodsService.GoodsEdit(post_data.id, post_data, function (success, data) {
                if (success) {
                    $scope.new_price = {
                        type: 'currency',
                        currency: $rootScope.ENV.business.currency,
                        price_decimal_digits: $rootScope.ENV.decimal_digits,
                        price_decimal_digits_visible: false,
                        special_account: $scope.specialAccountsList[0] || $scope.corporateSpecialAccountsList[0]
                    };

                    // add business currency to currenciesList
                    if ($scope.data.currenciesList.indexOf($scope.new_price.currency) == -1)
                        $scope.data.currenciesList.push($scope.new_price.currency);

                    $scope.model = data;
                    $scope.prices = $scope.model.price;
                    NotifyService.Success('', false);
                    $scope.isPriceModified = false;
                } else {
                    //  $scope.prices.splice($scope.prices.length - 1, 1);
                }
                if (callback) {
                    callback(success, data);
                }
            });
        }

        // $scope.inputPriceDecimalDigits = function (stage) {
        //     console.log('inputPriceDecimalDigits', stage )
        //     if(!!stage && stage.price && stage.decimal_digits) {
        //         stage.price.toFixed(parseInt(stage.decimal_digits));
        //     }
        // }
        $scope.changeTypePrice = function () {
            console.log('changeTypePrice', $scope.new_price.type);
            if ($scope.new_price.type == 'corporate-special-account') {
                $scope.new_price.special_account = $scope.corporateSpecialAccountsList[0];
            } else {
                $scope.new_price.special_account = $scope.specialAccountsList[0];
            }
        };
        /**
         * Receive event when user click on "Add price" button
         * @param form
         */
        $scope.addPriceClick = function (form) {
            console.info('FORM', form);

            // Check duplicates for currency
            function isValidPrice() {
                var result = true;
                if ($scope.new_price.currency) {
                    $scope.prices.forEach(function (item) {
                        if (item.type === $scope.new_price.type && item.currency === $scope.new_price.currency) result = false;
                    });
                } else {
                    result = false;
                }
                return result;
            }

            // Check duplicates for Account
            function isValidAccount() {
                var result = true;
                // corporate-special-account
                if ($scope.new_price.special_account.id) {
                    $scope.prices.forEach(function (item) {
                        if (item.type === 'special-account'
                            && item.special_account_id === $scope.new_price.special_account.id) result = false;
                    });
                } else {
                    result = false;
                }
                return result;
            }

            function isValidPriceDecimalDigits() {
                var result = true;
                if ($scope.new_price.price_decimal_digits !== $rootScope.ENV.decimal_digits) {
                    if ($scope.new_price.price_decimal_digits < 0 || $scope.new_price.price_decimal_digits > 8) {
                        result = false;
                    }
                }
                return result;
            }

            if ($scope.new_price.price &&
                isValidPriceDecimalDigits() &&
                (($scope.new_price.type == 'currency' && isValidPrice()) ||
                    (($scope.new_price.type == 'special-account' || $scope.new_price.type == 'corporate-special-account') && isValidAccount()))) {

                if (($scope.new_price.type == 'special-account' || $scope.new_price.type == 'corporate-special-account') &&
                    $scope.new_price.special_account) {
                    $scope.new_price.special_account_id = $scope.new_price.special_account.id;
                }

                // local tmp stage `price_decimal_digits_visible`

                if (!$scope.new_price.price_decimal_digits_visible) {
                    // pls remove by trello Roman
                    delete $scope.new_price.price_decimal_digits;
                }
                delete $scope.new_price.price_decimal_digits_visible;
                $scope.prices.push($scope.new_price);
                $scope.isPriceModified = true;

                $scope.new_price = {
                    type: 'currency',
                    price_decimal_digits: $rootScope.ENV.decimal_digits,
                    price_decimal_digits_visible: false
                };

                for (var i in form)
                    if (form[i] && form[i].$dirty)
                        form[i].$dirty = false;

                savePrice(function (success, data) {
                    if (!success) {
                        $scope.prices.splice($scope.prices.length - 1, 1);
                    }

                });
            } else {
                if (!$scope.new_price.price) {
                    form.price.$dirty = true;
                    form.price.$valid = false;
                }

                if ($scope.new_price.type === 'currency' && !isValidPrice()) {
                    form.currency.$dirty = true;
                    form.currency.$invalid = true;
                    form.currency.$error.duplicate = $scope.new_price.currency;
                    form.currency.$error.required = !$scope.new_price.currency;
                }

                if ($scope.new_price.type === 'special-account' && !isValidAccount()) {
                    form.special_account.$dirty = true;
                    form.special_account.$invalid = true;
                    form.special_account.$error.duplicate = $scope.new_price.special_account.id;
                    form.special_account.$error.required = !$scope.new_price.special_account.id;
                }

                if ($scope.new_price.type === 'corporate-special-account' && !isValidAccount()) {
                    form.corporate_special_account.$dirty = true;
                    form.corporate_special_account.$invalid = true;
                    form.corporate_special_account.$error.duplicate = $scope.new_price.special_account.id;
                    form.corporate_special_account.$error.required = !$scope.new_price.special_account.id;
                }

                if ($scope.new_price.price_decimal_digits_visible &&
                    ($scope.new_price.price_decimal_digits < 0 || $scope.new_price.price_decimal_digits > 8)) {
                    form.price_decimal_digits.$dirty = true;
                    form.price_decimal_digits.$invalid = true;
                }
            }
        };

        $scope.onKeyupPrice = function (e) {
            if (e.keyCode === 27) {
                $scope.onPriceCancelEditClick();
            }
        };

        /**
         * valid max price_decimal_digits
         */
        $scope.onKeydownPrice = function (event, price_decimal_digits) {
            var decimalCheck = event.target.value.split('.');
            if (!!decimalCheck[1] && !(event.which < 48 || event.which > 57)) {
                if (decimalCheck[1].length >= price_decimal_digits) {
                    event.preventDefault();
                    return false;
                }
            }

        };

        $rootScope.$watch('LOYALTIES', function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                $scope.data.loyaltiesList = angular.copy($rootScope.LOYALTIES);

                if ($rootScope.ENV.filters && $rootScope.ENV.filters.goods_list && $rootScope.ENV.filters.goods_list.loyalty_id)
                    $scope.filterHelper.id = $rootScope.ENV.filters.goods_list.loyalty_id;

                if ($rootScope.ENV.filters.global_filter && $rootScope.ENV.filters.global_filter.loyalty_id !== '0') {
                    $scope.data.currentFilter = $scope.data.loyaltiesList.find(function (filterItem) {
                        if (filterItem.filter_list_type === 'loyalty') {
                            if (filterItem.id === $rootScope.ENV.filters.global_filter.loyalty_id) {
                                return true;
                            }
                        } else if (filterItem.filter_list_type === 'pos' || filterItem.filter_list_type === 'register') {
                            if (filterItem.loyalty_id === $rootScope.ENV.filters.global_filter.loyalty_id) {
                                return true;
                            }
                        }
                    });
                }

                if (!$scope.filterHelper.id)
                    $scope.filterHelper.id = getFirstActive($scope.data.loyaltiesList).id;
            }
        });

        $scope.$watch('filterHelper.id', function (newValue, oldValue, scope) {
            if (newValue) {
                if ($scope._pageMode === 'show') {
                    SelectService.getGoodsCategoriesList(newValue, function (success, response) {
                        $scope.data.categoriesList = angular.copy(response);
                        $scope.data.categoriesList.unshift({
                            id: '0',
                            active: 1,
                            title: $filter('translate')('Without category')
                        });
                    });

                    doShow();

                    $rootScope.ENV.filters.goods_list = {
                        loyalty_id: newValue
                    };

                    $rootScope.ENV.filters.global_filter = {loyalty_id: newValue};

                    $rootScope.storeENV();
                }

                if ($scope._pageMode === 'create')
                    doCreate();
            }
        });

        $scope.$watch('model.loyalty_id', function (newValue, oldValue, scope) {
            if (newValue) {
                $scope.getGoodsCategoriesList(newValue, function (success, response) {
                    $scope.data.categoriesList = angular.copy(response);
                    $scope.data.categoriesList.unshift({
                        id: '0',
                        active: 1,
                        title: $filter('translate')('Without category')
                    });
                });
            }
        });

        $scope.$watch('data.categoryId', function (newValue, oldValue, scope) {
            if (newValue && newValue !== oldValue) {
                if ($scope._pageMode === 'show') {
                    doShow();
                }
            }
        });

        $scope.getSericeTypeFilterOptions = function ($select) {
            var allValue = {
                title: 'All',
                type: 'all'
            };

            var exists = $select.items.find(function (item) {
                return item.type == allValue.type;
            });

            if (!exists) {
                $select.items = [allValue].concat($select.items, $scope.data.characteristicList);
                $select.selected = allValue;
            }
        };

        // ============================================  RECOMMENDED VALUES TAB  ====================================================

        function initRecommendedValue() {
            console.log('initRecommendedValue');
            var multilanguageTitleObject = {};
            $scope.languageList = angular.copy($scope.platformSupportedLanguagesCodes);

            $scope.languageList.forEach(function (language) {
                multilanguageTitleObject[language] = '';
            });

            $scope.data.new_recommended_value = {
                type: 'currency',
                currency: $rootScope.ENV.business.currency,
                public_title: multilanguageTitleObject,
                color: 'ffffff'
            };

            $scope.recommendedValueValidator = {
                isTitleValid: function (form) {
                    if (form === undefined) {
                        form = $scope.data.new_recommended_value;
                    }
                    var titleNotEmpty = Object.values(form.public_title).find(function (title) {
                        return (title && title.length) > 0 ? true : false;
                    });

                    return titleNotEmpty ? true : false;
                },
                isCurrencyValid: function (form) {
                    if (form === undefined) {
                        form = $scope.data.new_recommended_value;
                    }
                    if (form.type === 'volume' || form.type === 'currency' && form.currency.length > 0) {
                        return true;
                    }

                    return false;
                },
                isColorValid: function (form) {
                    if (form === undefined) {
                        form = $scope.data.new_recommended_value;
                    }
                    return form.color ? true : false;
                },
                isSortOrderValid: function (form) {
                    if (form === undefined) {
                        form = $scope.data.new_recommended_value;
                    }
                    return Number.isInteger(form.sort_order) ? true : false;
                },
                isTypeValid: function (form) {
                    if (form === undefined) {
                        form = $scope.data.new_recommended_value;
                    }
                    return form.type && (form.type == 'currency' || form.type == 'volume') ? true : false;
                },
                isValueValid: function (form) {
                    if (form === undefined) {
                        form = $scope.data.new_recommended_value;
                    }
                    return form.value && (form.value > 0) ? true : false;
                }
            };
        }

        /**
         * Validate recommended values form
         */
        function validateRecommendedValue(formData) {

            var validationResult = {
                isValid: true,
                corruptedFields: []
            };

            for (var validatorName in $scope.recommendedValueValidator) {
                var isValid = $scope.recommendedValueValidator[validatorName](formData);
                if (!isValid) {
                    validationResult.corruptedFields.push(validatorName);
                    validationResult.isValid = false;
                }
            }

            return validationResult;
        }

        /**
         * Save to server Product's (goods) recommended values
         */

        function saveRecommendedValues() {
            var post_data = angular.copy($scope.model);

            post_data.preconfigured_values = [];
            var preconfigured_values = angular.copy($scope.recommended_values);
            for (var i in preconfigured_values) {
                preconfigured_values[i].sort_order = parseInt(i);
                post_data.preconfigured_values.push(preconfigured_values[i]);
            }

            post_data.color = hexToInt($scope.data.color);
            if (post_data.parent_id == '0') post_data.parent_id = null;

            GoodsService.GoodsEdit(post_data.id, post_data, function (success, data) {
                if (success) {
                    initRecommendedValue();

                    $scope.model = data;
                    $scope.recommended_values = $scope.model.preconfigured_values;
                    NotifyService.Success('', false);
                    $scope.data.isRecommendedValueModified = false;
                }
            });
        }

        $scope.saveRecommendedValues = saveRecommendedValues;
        /**
         * Open popup to add or edit recommended value
         */

        $scope.openModalCopyRecommendedValues = function () {

            $uibModal.open({
                animation: true,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/pages/goods/modals/modal.copy-recommended-values.html',
                controllerAs: 'popup',
                size: 'md',
                windowTopClass: 'modal-center',
                controller: function ($uibModalInstance) {

                    var popup = this;
                    popup.filterHelper = {
                        serviceType: isFuelMode ? 'fuel' : 'all'
                    };
                    popup.getPages = getTotalPaginatedPages;
                    popup.pageChange = function () {
                        showGoodsList();
                    };
                    popup.onCountChange = function (count) {
                        popup.data.pager.page = 1;
                        popup.data.pager.count = count;
                        $rootScope.ENV.PAGER_COUNT = count;
                        $rootScope.storeENV();

                        showGoodsList();
                    };
                    popup.pager_count = [10, 20, 50, 100];
                    popup.intToHEX = intToHEX;
                    popup.currentLangCode = $scope.currentLangCode;
                    popup.onFilterChange = function () {
                        if (filterTimeout) {
                            $timeout.cancel(filterTimeout);
                        }

                        filterTimeout = $timeout(function () {
                            popup.data.pager.page = 1;
                            showGoodsList();
                        }, 1000);
                    };

                    popup.onShowGoodsClick = function () {
                        popup.data.pager.page = 1;
                        showGoodsList();
                    };
                    popup.data = {
                        pager: {
                            page: 1,
                            count: $rootScope.ENV.PAGER_COUNT || 10
                        }
                    };

                    popup.goodsList = [];
                    popup.loyaltiesList = [];
                    popup.getLoyaltiesList = function () {
                        if (!popup.loyaltiesList.length) {
                            SelectService.getLoyaltiesList(function (success, data) {
                                if (success) {
                                    popup.loyaltiesList = angular.copy(data);

                                    if (!popup.filterHelper.id && $rootScope.ENV.filters && $rootScope.ENV.filters.goods_list &&
                                        $rootScope.ENV.filters.goods_list.loyalty_id) {
                                        popup.filterHelper.id = $rootScope.ENV.filters.goods_list.loyalty_id;
                                        showGoodsList();
                                    }
                                }
                            });
                        }

                    };

                    function showGoodsList() {
                        block_goods_list_modal.start();
                        var params = {
                            page: popup.data.pager.page,
                            count: popup.data.pager.count,
                            search_text: popup.data.searchText,
                            service_type: popup.filterHelper.serviceType
                        };
                        GoodsService.GoodsInLoyalty(popup.filterHelper.id, params, function (success, data) {
                            if (success) {
                                popup.goodsList = angular.copy(data.data);
                                // popup.goodsList.forEach(function(item) {
                                //   item.is_selected = false;
                                // });
                                popup.data.pager.total_rows_count = data.summary.total_rows_count;
                            }
                            block_goods_list_modal.stop();
                        });

                    }

                    popup.onCopyRecommendedValues = function (preconfigured_values) {
                        var copyRecommendedValuesUibModalInstance = $uibModalInstance;
                        $uibModal.open({
                            animation: true,
                            keyboard: true,
                            size: 'sm',
                            templateUrl: 'app/templates/modal.confirmation.html',
                            controllerAs: 'popup',
                            controller: function ($uibModalInstance) {
                                var popup = this;

                                popup.type = 'goods-copy-recommended-values';

                                popup.onSaveClick = function () {
                                    preconfigured_values = angular.copy(preconfigured_values).map(function (item) {
                                        delete item.id;
                                        delete item.item_id;
                                        return item;
                                    });
                                    $scope.recommended_values = preconfigured_values;
                                    saveRecommendedValues();
                                    $uibModalInstance.close();
                                    copyRecommendedValuesUibModalInstance.close();
                                };

                                popup.onCancelClick = function (exit) {
                                    $uibModalInstance.close();
                                };
                            }
                        });

                    };

                    popup.closeModal = function (exit) {
                        $uibModalInstance.close();
                    };
                }
            });

        };

        $scope.openModalRecommendedValue = function (recommendedValue) {
            if (recommendedValue === undefined) {
                recommendedValue = null;
            }

            $uibModal.open({
                animation: true,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/pages/goods/modals/modal.recommendedvalue.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-center',
                controller: function ($uibModalInstance) {

                    var popup = this;
                    popup.colors = $scope.data.colors;
                    popup.platformSupportedLanguagesCodes = angular.copy($scope.platformSupportedLanguagesCodes);
                    popup.recommendedValueLang = $scope.multilang.lang;
                    popup.currenciesList = $scope.data.currenciesList;
                    popup.recommendedValue = recommendedValue ? recommendedValue : $scope.data.new_recommended_value;
                    popup.recommendedValueValidator = $scope.recommendedValueValidator;
                    popup.corruptedFields = [];

                    if (popup.recommendedValue.color) {
                        popup.recommendedValue.color = intToHEX(popup.recommendedValue.color);
                    }

                    popup.changeTitleLang = function (lang) {
                        if (lang === undefined) {
                            lang = $scope.multilang.lang;
                        }

                        popup.recommendedValueLang = lang;
                    };

                    popup.selectColor = function (color) {
                        popup.recommendedValue.color = color;
                    };

                    popup.saveRecommendedValue = function () {
                        if (!popup.recommendedValue.sort_order) {
                            popup.recommendedValue.sort_order = $scope.recommended_values.length;
                        }

                        var validationResult = validateRecommendedValue(popup.recommendedValue);

                        if (validationResult.isValid) {
                            if (recommendedValue) {
                                var recommendedValueIndex = $scope.recommended_values.indexOf(recommendedValue);
                                $scope.recommended_values[recommendedValueIndex] = popup.recommendedValue;
                            } else {
                                $scope.recommended_values.push(popup.recommendedValue);
                            }

                            if (popup.recommendedValue.color) {
                                popup.recommendedValue.color = hexToInt(popup.recommendedValue.color);
                            }

                            saveRecommendedValues();
                            $uibModalInstance.close();
                        } else {
                            popup.corruptedFields = validationResult.corruptedFields;
                        }
                    };

                    popup.closeModal = function (exit) {
                        $uibModalInstance.close();
                    };
                }
            });
        };

        $scope.onRecommendedValueDeleteClick = function (recommended_value) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'sm',
                templateUrl: 'app/templates/modal.confirmation.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.type = 'goods-value';

                    popup.onSaveClick = function () {
                        var indexForDelete = $scope.recommended_values.indexOf(recommended_value);
                        $scope.recommended_values.splice(indexForDelete, 1);
                        $scope.data.isRecommendedValueModified = true;

                        saveRecommendedValues();
                        $uibModalInstance.close();
                    };

                    popup.onCancelClick = function (exit) {
                        $uibModalInstance.close();
                    };
                }
            });
        };

        $scope.popupPriceGroup = function () {
            $scope.modalAddBonuses = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/pages/goods/modals/modal.add-to-price-group.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.add = function () {

                    };
                    popup.onCancel = function () {
                        $uibModalInstance.close();
                    };
                }
            });
        };

        $scope.onSelectAllGoods = function () {
            for (var i in $scope.goodsList) {
                $scope.selectedGoods[$scope.goodsList[i].id] = $scope.selectedGoodsAll;
            }

        };

        function selectedGoodsCount() {
            var result = 0;
            for (var i in $scope.selectedGoods) {
                if ($scope.selectedGoods[i])
                    result += 1;
            }
            return result;
        }

    }
})
();

function nacsValidator() {
    return {
        require: 'ngModel',
        link: function (scope, element, attr, ngModelCtrl) {
            function fromUser(text) {
                if (text) {
                    var transformedInput = text.replace(/[^0-9]/g, '');

                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                return undefined;
            }

            ngModelCtrl.$parsers.push(fromUser);
        }
    };
}
